import classNames from 'clsx';
import type { MdComponentIndexProps } from '../type';
import { mapSpecChildrenFactory } from '../utils/mapSpecChildren';
import { transformCssUnit } from '../utils/transformCssUnit';
import { MarkdownColumn } from './Column';
import styles from './index.module.css';

const mapAcc = mapSpecChildrenFactory(MarkdownColumn);

const MarkdownColumns = function ({
  gap,
  className,
  style,
  children,
  ...props
}: React.PropsWithChildren<
  {
    gap?: string;
    className?: string;
    style?: React.CSSProperties;
  } & MdComponentIndexProps
>) {
  const config = mapAcc(
    children,
    ({ width, alignX = 'left', alignY = 'top', className, style }, key, child, index) => {
      return {
        key: key ?? String(index),
        width: width || '1fr',
        children: (
          <div
            className={classNames('w-full h-full markdown-child-root', className)}
            style={{
              ...style,
              alignSelf: (() => {
                switch (alignX || 'left') {
                  case 'left':
                    return 'flex-start';
                  case 'right':
                    return 'flex-end';
                  case 'center':
                    return 'center';
                  default:
                    return alignX;
                }
              })(),
              justifySelf: (() => {
                switch (alignY || 'top') {
                  case 'top':
                    return 'flex-start';
                  case 'bottom':
                    return 'flex-end';
                  case 'center':
                    return 'center';
                  default:
                    return alignY;
                }
              })(),
            }}
          >
            {child}
          </div>
        ),
      };
    },
  );

  return (
    <div
      data-first={props['data-first']}
      data-last={props['data-last']}
      className={classNames('markdown-child-root', styles.container, className)}
      style={{
        ...style,
        display: 'grid',
        gap: transformCssUnit(gap ?? '24'),
        gridTemplateColumns: config.map((item) => transformCssUnit(item.width)).join(' '),
      }}
    >
      {config.map((item) => item.children)}
    </div>
  );
};

MarkdownColumns.attributes = ['gap', 'className', 'style'];

export { MarkdownColumns };
